<template>
    <WaitingBlock v-if="isInitializing"/>
    <div v-else class="filters">
        <div ref="filtersRules" v-if="rules && rules.length > 0" :class="`filters-rules${rules.length > 4 ? ' filters-rules--overflow': ''}`">
            <!-- <div v-if="withRequirements" class="requirements-label">Check required rules</div> -->
            <div v-for="(rule, i) in rules" :key="`rules-${i}`"
                 :class="`filters-rule ${i === 0 ? filterUndeletable : ''}`">
                <div class="filters-rule-col">
                    <div v-if="sortable" class="filters-rule-handler">
                        <button class="sort-trigger" :disabled="i === 0" @click="moveRuleUp(i)"><i
                                class="fa fa-chevron-up"></i></button>
                        <button class="sort-trigger" :disabled="i === rules.length - 1" @click="moveRuleDown(i)"><i
                                class="fa fa-chevron-down"></i></button>
                    </div>
                    <div v-if="withRequirements" 
                        v-on:click.prevent="updateRule('isRequired', !rule.isRequired, i)"
                        :class="['filters-rule-checkbox', 'badge' ,rule.isRequired ? 'badge-success':'badge-danger']">
                        <label > {{rule.isRequired ? 'UnBreakable': 'Breakable'}}</label>
                    </div>
                    <div class="select-container">
                        <input v-on:click.prevent="rule.field.name.localeCompare('sources') !== 0 && toggleSelectorField(i)" readonly :value="getFieldLabel(rule.field)" type="text">
                        <i v-if="rule.field.name.localeCompare('sources') != 0" class="fas fa-chevron-down"></i>
                    </div>
                </div>

                <div class="filters-rule-col">
                    <div class="select-container">
                        <template v-if="rule.field.type === 'equals'">
                            <p>is equals to</p>
                            <input type="hidden" v-model="rule.comparison" value="equals"/>
                        </template>

                        <template v-else>
                            <select v-if="rule.field.type === 'alpha'" v-model="rule.comparison" class="select"
                                    name="comparisons-alpha">
                                <option v-for="comp in Constants.comparisons.alpha"
                                        :key="`${rule.field.name}-alpha-${comp.name}`" :value="comp.name">{{ comp.label
                                    }}
                                </option>
                            </select>

                            <select v-if="rule.field.type === 'contains'" v-model="rule.comparison" class="select"
                                    name="comparisons-contains">
                                <option v-for="comp in Constants.comparisons.contains"
                                        :key="`${rule.field.name}-contains-${comp.name}`" :value="comp.name">{{
                                    comp.label }}
                                </option>
                            </select>

                            <select v-if="rule.field.type === 'numeric'" v-model="rule.comparison"
                                    v-on:change="onNumericChange($event, rule)" class="select"
                                    name="comparisons-numeric">
                                <option v-for="comp in Constants.comparisons.numeric"
                                        :key="`${rule.field.name}-numeric-${comp.name}`" :value="comp.name">{{
                                    comp.label }}
                                </option>
                            </select>

                            <select v-if="rule.field.type === 'list' || rule.field.type === 'select'" v-model="rule.comparison" class="select" name="comparisons-list">
                                <option v-for="comp in Constants.comparisons.list"
                                        :key="`${rule.field.name}-list-${comp.name}`" :value="comp.name">{{ comp.label
                                    }}
                                </option>
                            </select>
                            <select v-if="rule.field.type === 'include'" v-model="rule.comparison" class="select" name="comparisons-include">
                                <option v-for="comp in Constants.comparisons.include" :key="`${rule.field.name}-list-${comp.name}`" :value="comp.name">
                                    {{ comp.label }}
                                </option>
                            </select>
                            <select v-if="rule.field.type === 'exclude'" v-model="rule.comparison" class="select" name="comparisons-exclude">
                                <option v-for="comp in Constants.comparisons.exclude" :key="`${rule.field.name}-list-${comp.name}`" :value="comp.name">
                                    {{ comp.label }}
                                </option>
                            </select>
                            <i class="fas fa-chevron-down"></i>
                        </template>
                    </div>
                </div>

                <div class="filters-rule-col">
                    <SelectorStrings v-if="rule.field.name === 'title' || rule.field.name === 'description' || rule.field.name === 'artistName'"
                                     :originalValue="rule.value" :top="rules.length > 4 && i > rules.length - 2"
                                     :placeholder="rule.field.label"
                                     @onValueChanged="onValueChanged('title', rule, $event)"/>
                    <TagsBadgeList v-else-if="rule.field.name === 'tags'" :tags="rule.value"
                                   @click.prevent="openParameterSelector('showTagsSelector','modalTags', rule)"/>
                    <InstrumentsBadgeList v-else-if="rule.field.name === 'instruments'" :instruments="rule.value"
                                 @click.prevent="openParameterSelector('showInstrumentsSelector','modalInstruments', rule)"/>
                  <VocalInstrumentsBadgeList v-else-if="rule.field.name === 'vocalInstruments'" :vocalInstruments="rule.value"
                                        @click.prevent="openParameterSelector('showVocalInstrumentsSelector','modalVocalInstruments', rule)"/>
                    <TypesBadgeList v-else-if="rule.field.name === 'type'" :types="rule.value"
                                    @click.prevent="openParameterSelector('showTypeSelector','modalTypes', rule)"/>
                    <BoxesBadgeList v-else-if="rule.field.name === 'boxes'" :boxes="rule.value"
                                    @click.prevent="openParameterSelector('showBoxesSelector','modalBoxes', rule)"/>
                    <SourcesBadgeList v-else-if="rule.field.name === 'sources' " :sources="rule.value"
                                      @click.prevent="openParameterSelector('showSourcesSelector','modalSources', rule)"/>
                    <SourcesBadgeList v-else-if="rule.field.name === 'exc-sources'" :sources="rule.value"
                                      @click.prevent="openParameterSelector('showExcSourcesSelector','modalExcSources', rule)"/>
                   
                     <LabelTextInput v-else-if="rule.field.name === 'labels'" :labels="rule.value"
                                    @click.prevent="openParameterSelector('showLabelSelector','modalLabels', rule)"/>
                    <StyleBadgeList v-else-if="rule.field.name === 'styles'" :styles="rule.value"
                                    @click.prevent="openParameterSelector('showStyleSelector','modalStyles', rule)"/>

                  <StyleBadgeList v-else-if="rule.field.name === 'targets'" :styles="rule.value" :placeholderValue="'Targets'"
                                  @click.prevent="openParameterSelector('showTargetSelector','modalTargets', rule)"/>
                  <StyleBadgeList v-else-if="rule.field.name === 'categories'" :styles="rule.value" :placeholderValue="'Categories'"
                                  @click.prevent="openParameterSelector('showCategoriesSelector','modalCategories', rule)"/>

                    <ArtistBadgeList v-else-if="rule.field.name === 'artists'" :artists="rule.value"
                                     @click.prevent="openParameterSelector('showArtistSelector','modalArtists', rule)"/>
                    <LanguageBadgeList v-else-if="rule.field.name === 'languages'" :languages="rule.value"
                                       @click.prevent="openParameterSelector('showLanguageSelector','modalLanguages', rule)"/>
                    <MultiChoiceTextInput v-else-if="rule.field.name === 'mood'" ref="multiMood" :multiselect="true"
                                          :originalValue="rule.value" :enumValues="Constants.moods"
                                          @onValueChanged="onValueChanged('mood', rule, $event)"/>
                    <MultiChoiceTextInput v-else-if="rule.field.name === 'energy'" ref="multiEnergy" :multiselect="true"
                                          :originalValue="rule.value" :enumValues="Constants.energies"
                                          @onValueChanged="onValueChanged('energy', rule, $event)"/>
                    <MultiChoiceTextInput v-else-if="rule.field.name === 'gender'" ref="multiGender" :multiselect="true"
                                          :originalValue="rule.value" :enumValues="Constants.genders"
                                          @onValueChanged="onValueChanged('gender', rule, $event)"/>
                    <ToggleInput v-else-if="rule.field.name === 'isExplicit'" :originalValue="rule.value"
                                 :id="`query-${i}`" @onValueChanged="onValueChanged('isExplicit', rule, $event)"/>
                    <template v-else-if="rule.field.name === 'duration'">
                        <template v-if="rule.comparison === 'between'">
                            <input v-model="rule.value.from" type="number" :placeholder="'in ms'"/>
                            <span class="range-text">and</span>
                            <input v-model="rule.value.to" type="number" :placeholder="'in ms'"/>
                        </template>
                        <DurationInput v-else :originalValue="rule.value"
                                       @onValueChanged="onValueChanged('duration', rule, $event)"/>
                    </template>
                    <template v-else-if="rule.field.name === 'publicationDate'">
                        <template v-if="rule.comparison === 'between'">
                            <Datepicker v-model="rule.value.from" :disabledDates="{from: new Date()}" placeholder="From"/>
                            <span class="range-text">and</span>
                            <Datepicker v-model="rule.value.to" :disabledDates="{from: new Date()}" placeholder="To"/>
                        </template>
                        <Datepicker v-else v-model="rule.value" :disabledDates="{from: new Date()}" :placeholder="rule.field.label"/>
                    </template>
                  <template v-else-if="rule.field.name === 'country'" >
                    <Dropdown v-if="rule.field.name === 'country'" v-model="rule.value"  :options="countries" optionLabel="name"
                              @change="updateIndex(rule)"
                              placeholder="Select a Country" class="w-full md:w-27rem" style="border: hidden; border-bottom: 1px solid #ced4da;">
                      <template #value="slotProps">
                        <div v-if="slotProps.value" class="flex align-items-center" >
<!--                          <span class="flag-icon flag-icon-squared" :class="['flag-icon-' + slotProps.value.code.toLowerCase()]"></span>&nbsp;&nbsp;-->
                          <span>{{ slotProps.value.name }}</span>
                        </div>
                        <span v-else>
                                {{ slotProps.placeholder }}
                            </span>
                      </template>
                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <div>
<!--                            <span class="flag-icon flag-icon-squared" :class="['flag-icon-' + slotProps.option.code.toLowerCase()]"></span>&nbsp;-->
                            {{ slotProps.option.name }}</div>
                        </div>
                      </template>
                    </Dropdown>
                  </template>
                    <SelectorNumbers
                            v-else-if="['year', 'bpm'].includes(rule.field.name) && rule.comparison === 'equals'"
                            :originalValue="rule.value" :top="rules.length > 4 && i > rules.length - 2"
                            :placeholder="rule.field.label"
                            @onValueChanged="onValueChanged(rule.field.name, rule, $event)"/>
                    <template v-else>
                        <template v-if="rule.comparison === 'between'">
                            <input v-model="rule.value.from" type="number" :placeholder="rule.field.label"/>
                            <span class="range-text">and</span>
                            <input v-model="rule.value.to" type="number" :placeholder="rule.field.label"/>
                        </template>
                        <input v-else v-model="rule.value" type="number" :placeholder="rule.field.label"/>
                    </template>

                    <button v-on:click.prevent="deleteRule(rule)" class="filters-rule-delete">
                        <template
                                v-if="$route.name === 'SmartBoxFilters' || $route.name === 'LibraryAdvancedSearchQuery'">
                             <template v-if="
                                   ($route.name === 'SmartBoxFilters' && rule.field.name !== 'boxes')
                                || ($route.name === 'LibraryAdvancedSearchQuery' && rule.field.name !== 'sources')">
                                <i class="fas fa-times"></i>
                            </template>
                        </template>
                        <template v-else>
                            <i class="fas fa-times"></i>
                        </template>
                    </button>
                </div>
            </div>
        </div>

        <div class="filters-toggles">
            <button v-on:click.prevent="addRule" :disabled="currentFields.length >= Constants.fields.length"
                    class="filters-toggles-rule">
                <i class="fas fa-plus"></i>
                Add filter
            </button>

            <button v-on:click.prevent="save" class="filters-toggles-search">{{ toggleLabel || 'Save' }}</button>
        </div>
        <SelectorType v-if="false" ref="modalTypes" @newValue="newValue"/>
        <SelectorField v-show="false" ref="modalFields" @newValue="updateRuleField" :currentFields="currentFields"/>
        <SelectorTags  ref="modalTags" :stationUid="currentStationUid"
                      :noModalEdit="true" @newValue="newValue" @onHidden="resetModalState('showTagsSelector')"/>
        <SelectorInstruments  ref="modalInstruments" :stationUid="currentStationUid"
                    :noModalEdit="true" @newValueInstruments="newValue" @onHidden="resetModalState('showInstrumentsSelector')"/>
      <SelectorVocalInstruments  ref="modalVocalInstruments" :stationUid="currentStationUid"
                           :noModalEdit="true" @newValueVocalInstruments="newValue" @onHidden="resetModalState('showVocalInstrumentsSelector')"/>
        <SelectorBoxes  ref="modalBoxes" :stationUid="currentStationUid"
                       :noModalEdit="true" @newValue="newValue" @onHidden="resetModalState('showBoxesSelector')"/>
        <SelectorSources  ref="modalSources" :stationUids="selectedStationUids"
                         :noModalEdit="true" @newValue="(type, stations) => newValue('exc-sources', stations)" @onHidden="resetModalState('showSourcesSelector')"/>
        <SelectorSources  ref="modalExcSources" :stationUids="selectedExcludedStationUids"
                         :noModalEdit="true" @newValue="newValue" @onHidden="resetModalState('showExcSourcesSelector')"/>
        <SelectorStyle ref="modalStyles" :stationUid="currentStationUid"
                       :noModalEdit="true" :noModalUpdate="true" @newValue="newValue" @onHidden="resetModalState('showStyleSelector')"/>
        <SelectorArtist  ref="modalArtists" :stationUid="currentStationUid"
                        :noModalEdit="true" :noModalUpdate="true" @newValue="newValue" @onHidden="resetModalState('showArtistSelector')"/>
        <SelectorLanguages  ref="modalLanguages" :stationUid="currentStationUid"
                           :noModalEdit="true" @newValue="newValue"
                           @onHidden="resetModalState('showLanguageSelector')"/>
        <SelectorLabels  ref="modalLabels" :multiselect="true"
                        :stationUid="currentStationUid" :noModalUpdate="true" :noModalEdit="true" @newValue="newValue"
                        @onHidden="resetModalState('showLabelSelector')"/>
      <SelectorCategories
          ref="modalCategories"
          :stationUid="currentStationUid"
          :noModalEdit="true"
          @newValueCategories="newValue"
          @onHidden="resetModalState('showCategoriesSelector')"
      />
      <SelectorTargets
          ref="modalTargets"
          :stationUid="currentStationUid"
          :noModalEdit="true"
          @newValueTargets="newValue"
          @onHidden="resetModalState('showTargetSelector')"
      />
    </div>
</template>

<script>
    // Dependencies
    import {HTTP} from "@/utils/http";
    // Utils
    import FilterToRule from '@/utils/FilterToRule';
    import RuleToFilter from '@/utils/RuleToFilter';
    // Variables
    import Constants from '../../store/constants.js';
    import Apis from '../../apis/index.js';
    // Components
    import Datepicker from 'vuejs-datepicker';
    import SelectorTags from '../Library/SelectorTags.vue';
    import SelectorInstruments from "../Boxes/SelectorInstrument";
    import SelectorVocalInstruments from "../Boxes/SelectorVocalInstrument";
    import SelectorType from '../Library/SelectorType.vue';
    import SelectorBoxes from '../Library/SelectorBoxes.vue';
    import SelectorField from '../Library/SelectorField.vue';
    import SelectorStyle from '../Library/SelectorStyle.vue';
    import SelectorArtist from '../Library/SelectorArtist.vue';
    import SelectorLabels from '../Library/SelectorLabels.vue';
    import SelectorNumbers from '../Library/SelectorNumbers.vue';
    import SelectorStrings from '../Library/SelectorStrings.vue';
    import SelectorLanguages from '../Library/SelectorLanguages.vue';
    import TagsBadgeList from '@/components/common/TagsBadgeList.vue';
    import InstrumentsBadgeList from '@/components/common/InstrumentsBadgeList.vue';
    import VocalInstrumentsBadgeList from '@/components/common/VocalInstrumentsBadgeList.vue';
    import TypesBadgeList from '@/components/common/TypesBadgeList.vue';
    import BoxesBadgeList from '@/components/common/BoxesBadgeList.vue';
    import ArtistBadgeList from '@/components/common/ArtistBadgeList.vue';
    import StyleBadgeList from '@/components/common/StyleBadgeList.vue';
    import LanguageBadgeList from '@/components/common/LanguageBadgeList.vue';
    import TextInput from '../common/TextInput.vue';
    import ToggleInput from '../common/ToggleInput.vue';
    import NumberInput from '../common/NumberInput.vue';
    import DurationText from '../common/DurationText.vue';
    import DurationInput from '../common/DurationInput.vue';
    import LabelTextInput from '../common/LabelTextInput.vue';
    import MultiChoiceTextInput from '../common/MultiChoiceTextInput.vue';
    import WaitingBlock from '@/components/common/WaitingBlock.vue';

    import moment from 'moment'
    import {mapActions, mapGetters, mapState} from "vuex";
    import SourcesBadgeList from "@/components/common/SourcesBadgeList";
    import SelectorSources from "@/components/Library/Track/SelectorSources";
    import {safeObj} from "@/utils/safeObj";
    import SelectorCategories from "@/components/Boxes/SelectorCategorie";
    import SelectorTargets from "@/components/Boxes/SelectorTarget";
    import Dropdown from 'primevue/dropdown';

    export default {
        props: ['type', 'filters', 'toggleLabel', 'addDefault', 'filteredBoxes', 'withRequirements', 'sortable', 'sync','disableBoxesSelection','disableStationsSelection'],
        components: {
            Dropdown,
            SelectorSources,
            SourcesBadgeList,
            Datepicker,
            SelectorTags,
            SelectorInstruments,
            SelectorVocalInstruments,
            SelectorType,
            SelectorBoxes,
            SelectorStyle,
            SelectorNumbers,
            SelectorStrings,
            SelectorField,
            SelectorArtist,
            SelectorLabels,
            SelectorLanguages,
            TagsBadgeList,
            InstrumentsBadgeList,
            VocalInstrumentsBadgeList,
            TypesBadgeList,
            BoxesBadgeList,
            StyleBadgeList,
            ArtistBadgeList,
            LanguageBadgeList,
            TextInput,
            ToggleInput,
            NumberInput,
            DurationInput,
            LabelTextInput,
            MultiChoiceTextInput,
            DurationText,
            WaitingBlock,
            SelectorCategories,
            SelectorTargets
        },
        computed: {
            ...mapActions('tracks', ["loadCountiesList"]),
            ...mapState({
                selectedBoxes: state => state.Boxes.selectedBoxes
            }),
            ...mapGetters(['currentRadio']),
            Constants: () => Constants,
            currentFields() {
                const fields = this.rules.map(rule => {
                    return rule.field.name;
                });

                return fields;
            },
            currentStationUid() {
                return this.$route.params.stationUid;
            },
            filterUndeletable() {
                if (this.$route.name === 'SmartBoxFilters' || 
                    this.$route.name === 'LibraryAdvancedSearchQuery') {
                    return 'filters-rule__first'
                }
            },
            selectedExcludedStationUids() {
                var stationRule = this.rules.filter(r => r.field.name==="exc-sources");
                if (stationRule && stationRule.length > 0)
                {
                    var uids = stationRule[0]
                                    .value
                                    .filter(itm => itm != null)
                                    .map(station => station.uid);
                    if (uids.length > 0) return uids;
                }       
                return [];         
            },
            selectedStationUids() {
                var stationRule = this.rules.filter(r => r.field.name==="sources");
                if (stationRule && stationRule.length > 0)
                {
                    var uids = stationRule[0]
                                    .value
                                    .filter(itm => itm != null)
                                    .map(station => station.uid);

                    if ( uids.length > 0) return uids;
                }               
                return [this.currentStationUid]
            }
        },
        mounted() {
          this.$store.dispatch("tracks/loadCountiesList")
          this.countries =this.$store.state.tracks.countries;
          const interval =  setInterval(() => {
                this.countries =this.$store.state.tracks.countries;
                if (this.countries.length > 0){
                  clearInterval(interval)
                }

              }

              , 100);
          this.getListTargets();
          this.getListCategories();


        },
        data() {
            return {
                targetList: null,
                categoriesList: null,
                currentRuleIndex: 0,
                isInitializing: false,
                rules: [],
                countries:[],
                viewState: {
                    isLoadingTracks: false,
                    isRemovingTracks: false,
                    isInSearch: false,
                    showTagsSelector: false,
                    showInstrumentsSelector: false,
                    showVocalInstrumentsSelector: false,
                    showTypesSelector: false,
                    showBoxesSelector: false,
                    showSourcesSelector: false,
                    showExcSourcesSelector:false,
                    showArtistSelector: false,
                    showLanguageSelector: false,
                    showStyleSelector: false,
                    showLabelSelector: false,
                    showDeleteConfirmation: false,
                    showEditMix: false,
                    showCategoriesSelector: false,
                    showTargetSelector: false,
                },
                defaultSources: {}
            }
        },
        methods: {
           getListTargets(){
            if (!this.targetList) {
              try {
                HTTP.get(Apis.parameters.targets)
                    .then((result) => {
                      if (result){
                        this.targetList = result.data.dataItem;
                        if(this.categoriesList) {
                          this.setupRules();
                        }
                      }
                    });
              } catch (e) {
                console.log(e);
              }
            }
          },
          getListCategories() {
            if (!this.categoriesList) {
              try {
                HTTP.get(Apis.parameters.categories)
                    .then((result) => {
                      if (result){
                        this.categoriesList = result.data.dataItem;
                        if(this.targetList) {
                          this.setupRules();
                        }

                      }
                    });
              } catch (e) {
                console.log(e);
              }
            }
          },
          getTarget(id){
            for (let i = 0; i <  this.targetList.length; i++) {
              if (this.targetList[i].id === id) {
                return this.targetList[i].name;
              }
            }
          },
          getCategories(id){
            for (let i = 0; i <  this.categoriesList.length; i++) {
              if (this.categoriesList[i].id === id) {
                return this.categoriesList[i].name;
              }
            }
          },
            toggleSelectorField(index) {
                this.currentRuleIndex = index
                this.$refs.modalFields.changeField(this.rules[this.currentRuleIndex].field);
                this.$refs.modalFields.show();
            },
            updateIndex(rule) {
                this.currentRuleIndex = this.rules.indexOf(rule);
            },
            updateRuleField(field) {
             console.log('field', field)
             console.log('this.currentRuleIndex', this.currentRuleIndex)
             console.log('this.rules', this.rules)
                const currentRule = this.rules[this.currentRuleIndex];
                if (currentRule.field !== field) {
                    currentRule.field = field;
                    currentRule.value = field.default;
                    currentRule.comparison = this.Constants.comparisons[field.type][0].name;
                }
                // reset last value
                this.rules[this.currentRuleIndex].value = currentRule.value;
              console.log('this.rules', this.rules)
            },
            cleanRules() {
                this.rules = []
                this.currentRuleIndex = 0
            },
            async initRules(filters) {
                console.log('////////////////////////////////////initRules', filters)
                this.cleanRules();

                for (let i = 0; i < filters.length; i++) {
                    const filter = filters[i];

                  console.log(filter)
                  if (filter.fieldName === 'titlenormalized') {
                    filter.fieldName = 'title';
                  }
                  if (filter.fieldName === 'namenormalized') {
                    filter.fieldName = 'artist';
                    filter.source = 'artistName';
                  }

                    const rule = { field: FilterToRule.field(filter) };
                    console.log(filter, rule)
                    if (this.withRequirements) {
                        rule.isRequired = filter.isRequired
                    }
                    if (!rule.field) {
                        continue;
                    }


                    if (rule.field.name === 'boxes') {
                      console.log('boxes')
                        rule.value = this.filteredBoxes || filter.values.map((uid) => {
                            let currentBox = this.selectedBoxes && this.selectedBoxes.filter(e => e.uid === uid)
                            if (!!currentBox.length) {
                                return {
                                    uid,
                                    name: currentBox[0].name
                                }
                            }
                        });
                        if (filter && filter.valuesName){
                          rule.value = filter.valuesName.map((item) => {
                            if (rule.field.name === filter.source){
                              return {
                                uid: item.uid,
                                name: item.name,
                              }
                            }
                          });
                        }
                    }else if (rule.field.name === 'targets' ||
                        rule.field.name === 'categories'  ||
                        rule.field.name === 'country' ||
                        rule.field.name === 'instruments' ||
                        rule.field.name === 'vocalInstruments'
                    ) {
                      console.log('else if')
                      if (filter && filter.valuesName){
                        rule.value = filter.valuesName.map((item) => {
                          if (rule.field.name === filter.source){
                            return {
                              'id': item.id,
                              'name': item.name,
                            }
                          }
                        });
                      }else {
                        if (rule.field.name.toLowerCase() === filter.source.toLowerCase()) {
                        rule.value = filter.values.map((id) => {
                          if (rule.field.name === 'categories'  ){
                            return {
                              'id': id,
                              'name':    this.getCategories(id),
                            }
                          } else {
                            return {
                              'id': id,
                              'name':    this.getTarget(id),
                            }
                          }
                        });
                        }
                      }
                      if (rule.field.name === 'country') {
                        rule.value = {
                          id :filter.valuesName[0].id,
                          code :filter.valuesName[0].code,
                          name :filter.valuesName[0].name,
                        };
                      }
                     } else {
                        let tmpRuleValue= await FilterToRule.value(filter, rule.field.name);
                        rule.value = tmpRuleValue;
                    }
                    rule.comparison = FilterToRule.comparison(filter, rule.field.name);
                    this.rules.push(rule);
                }

                this.isInitializing = false;
            },
            addRule() {
                const rule = {};
                let availableField = [];
                let currentStation = this.currentRadio;
                if (this.type === 'box' && (this.currentFields.length === 0 || !this.currentFields.includes('boxes'))) {
                    availableField = Constants.fields.find(field => field.name === 'boxes')
                } else if (this.type === 'search' && !this.rules.length)  {
                    availableField = Object.assign({}, Constants.fields.find(field => field.name === 'sources'));
                    availableField.default = [currentStation || { uid: this.currentStationUid, name: "Current Station" }];
                } else {
                    availableField = Constants.fields.filter(field => {
                        let notCurrent = true;
                        
                        this.currentFields.map(f => {
                            if(f === 'boxes') return false;
                            if(f === 'sources') return false;
                            if (f === field.name) {
                                notCurrent = false;
                            }

                            return true;
                        });

                        return notCurrent;
                    })[0];
                }
                rule.field = availableField;
                rule.value = availableField.default;
                rule.comparison = this.Constants.comparisons[availableField.type][0].name;
                this.rules.push(rule);
                // Timeout to wait for update
                setTimeout(() => {
                    if (this.$refs.filtersRules)
                        this.$refs.filtersRules.scrollTop = this.$refs.filtersRules.scrollHeight;
                }, 50);
            },
            deleteRule(rule) {
                this.rules = this.rules.filter(item => item !== rule);
            },
            newValue(type, value) {
                (this.rules[this.currentRuleIndex]||{}).value = value;
            },
            updateRule(field, value, ruleIndex){
                this.rules[ruleIndex][field] = value;
                this.$forceUpdate();
            },
            onValueChanged(field, rule, $event) {
                this.updateIndex(rule);
                rule.value = $event
            },
            onNumericChange(e, rule) {
                if (rule.comparison === 'between') {
                    rule.value = {from: '', to: ''};
                } else {
                    rule.value = '';
                    // if (rule.value.hasOwnProperty('to') || rule.value.hasOwnProperty('from')) {
                    // }
                }
            },
            resetModalState(toggler) {
                this.$set(this.viewState, toggler, false);
            },
            openParameterSelector(toggler, selectorName, rule) {
                this.updateIndex(rule);
                this.viewState[toggler] = true;
                console.log(selectorName , toggler)

                try {
                    var modalSelector = this.$refs[selectorName];
                    console.log(this.$refs , modalSelector)
                    if (modalSelector) {
                        modalSelector.edit(rule.value);
                    }
                } catch (e) {
                    console.log("exc:", e);
                }
            },
            save() {
                const filters = this.rules.reduce((acc, rule) => {
                    const {name} = rule.field;
                    const filter = {
                        source: null,
                        type: null,
                        operator: null,
                        fieldName: null,
                        include: true,
                        values: [],
                        from: null,
                        to: null,
                        isRequired: false
                    };

                    for (var prop in filter) {

                        if (prop === 'isRequired') {
                            filter[prop] = rule.isRequired
                            continue
                        }

                        if (Object.prototype.hasOwnProperty.call(filter, prop)) {
                            filter[prop] = RuleToFilter[prop](rule, name);
                        }
                    }
                    console.log('---------------------------')
                    console.log(filter , name)
                      if (name === 'title' ) {
                        filter.fieldName = "titlenormalized";
                      }
                    if (name === 'artistName') {
                      filter.fieldName = "namenormalized";
                      filter.source = "artists";
                    }
                    if (name === 'boxes') {
                      const valuesName = [...rule.value].map(r => r);
                      filter.valuesName = valuesName;
                    }

                    if (name === 'publicationDate') {
                        if (rule.comparison === 'between') {
                            filter.from = moment(rule.value.from).startOf('day')
                            filter.to = moment(rule.value.to).endOf('day')
                        } else if (rule.comparison === 'equals') {
                            const date = moment(rule.value)
                            filter.from = date.startOf('day')
                            filter.to = date.clone().endOf('day')
                        } else if (rule.comparison === 'lower') {
                            const date = moment(rule.value)
                            filter.from = null
                            filter.to = date.startOf('day')
                        } else if (rule.comparison === 'greater') {
                            const date = moment(rule.value)
                            filter.from = date.endOf('day')
                            filter.to = null
                        }
                    }

                    if (name === 'targets' | name === 'categories' ){
                      const values = [...rule.value].map(r => r.id);
                      const valuesName = [...rule.value].map(r => r);
                      filter.source = name;
                      filter.operator = 'equals'
                      filter.fieldName = 'id';
                      filter.include = rule.comparison === 'include' ? true : false;
                      filter.type = 'ValueList';
                      filter.values = values;
                      filter.valuesName = valuesName;
                    }
                  if (name === 'instruments' ||  name === 'vocalInstruments'  ){
                    const values = [...rule.value].map(r => r.id);
                    const valuesName = [...rule.value].map(r => r);
                    filter.source = name;
                    filter.operator = 'equals'
                    filter.fieldName = 'id';
                    filter.include = rule.comparison === 'include' ? true : false;
                    filter.type = 'ValueList';
                    filter.values = values;
                    filter.valuesName = valuesName;
                  }
                  if (name === 'position' | name === 'weeks'  ){
                    const values = [...rule.value].map(r => r);
                    const valuesName = [...rule.value].map(r => r);
                    filter.source = 'charts';
                    filter.operator = null;
                    filter.fieldName = name;
                    filter.include = rule.comparison === 'include' ? true : false;
                    filter.type = 'range';
                    filter.values = values;
                    filter.valuesName = valuesName;
                    filter.from = 1;
                    filter.to = null;
                  }
                  if ( name === 'country' ){
                    const values = rule.value.id;
                    const valuesName = rule.value;
                    filter.source = 'charts';
                    filter.operator = 'equals'
                    filter.fieldName = 'countryID';
                    filter.include = rule.comparison === 'include' ? true : false;
                    filter.type = 'ValueList';
                    filter.values = [values];
                    filter.valuesName = [valuesName];
                    filter.from = null;
                    filter.to = null;
                  }
                    //-------------------------------------------------------------------
                    // Don't touch it : station selection
                    //-------------------------------------------------------------------
                    if (name === 'sources') {
                        const values = [...rule.value].map(r => r.uid);
                        filter.source = 'stations';
                        filter.operator = 'equals'
                        filter.fieldName = 'uid';
                        filter.values = values
                    }
                    if (name == 'exc-sources')
                    {
                        const values = [...rule.value].map(r => r.uid);
                        filter.source = 'stations';
                        filter.operator = 'equals'
                        filter.fieldName = 'uid';
                        filter.include = false;
                        filter.values = values
                    }
                    //-------------------------------------------------------------------

                    acc.push(filter);
                    return acc;
                }, []);
                 this.$emit('save', filters);
            },
            // Helpers
            getFieldLabel(field) {
                return this.Constants.fields.filter(f => f.name === field.name)[0].label;
            },
            setupRules() {
                this.isInitializing = true;

                if (this.addDefault) {
                    if (!this.rules || this.rules.length === 0) {
                        this.addRule();
                    }
                }

                if (this.filters && this.filters.length > 0) {
                    this.initRules(this.filters);
                }
                this.isInitializing = false
            },
            moveRuleUp(ruleIndex) {
             console.log('moveRuleUp')

                if (ruleIndex <= 0) {
                    return
                }

                this.rules.splice(ruleIndex - 1, 0, this.rules.splice(ruleIndex, 1)[0])
            },
            moveRuleDown(ruleIndex) {
                if (ruleIndex >= this.rules.length) {
                    return
                }

                this.rules.splice(ruleIndex + 1, 0, this.rules.splice(ruleIndex, 1)[0])
            }
        },
        watch: {
            filters: {
                handler: function () {
                    if (this.sync) {
                      this.getListTargets();
                      this.getListCategories();
                    }
                },
                deep: true
            },
            // currentRadio: {
            //     handler: function (newV) {
            //         console.log('this.rules[0]: ', this.rules[0]);
            //         //this.$set(this.rules[0], 'value', newV)
            //     }
            // }
        }
    }
</script>


<style lang="scss" scoped>
    .filters {
        padding: 0 25px;
        width: 100%;
        max-height: 100%;

        &-rules {
            padding: 20px 15px 20px 0;
            max-height: calc(100vh - 197px);

            &--overflow {
                overflow-y: auto;
            }
        }

        &-rule {
            display: flex;
            align-items: center;
            margin: 0 -15px;

            &.filters-rule__first {
                background: #f0f1f3;
                border-radius: 5px;
                border: 1px solid #ced4da;

                input[type="text"],
                select.select {
                    border-bottom: none;
                }
            }

            &-col {
                padding: 0 15px;
                display: flex;
                align-items: center;
                flex-wrap: 0;
                width: 30%;

                &:first-child {
                    width: 40%;
                }

                &:last-child {
                    display: flex;
                    justify-content: space-between;
                    width: 40%;
                }
            }

            &-delete {
                border: 0;
                background: none;
                padding: 0 0 0 15px;
                outline: none;

                i {
                    font-size: 14px;
                    color: #d2d2d2;
                    transition: color .2s ease-in-out;
                }
            }

            + .filters-rule {
                margin-top: 10px;
            }
        }

        &-toggles {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 20px 0;
            width: 100%;

            &-rule {
                border: 0;
                background-color: white;
                outline: none;

                &[disabled] {
                    opacity: 0;
                }

                i {
                    font-size: 12px;
                }
            }
        }

        .select-container {
            position: relative;
            width: 100%;

            p {
                font-size: 14px;
                line-height: 1;
                margin-bottom: 0;
            }

            select {
                display: block;
                width: 100%;
                padding: 9px 0;
                border: 0;
                border-bottom: 1px solid #ced4da;
                border-radius: 0;
                background: none;
                -webkit-appearance: none;
                appearance: none;
                font-size: 14px;
                line-height: 1;
                cursor: pointer;
                outline: none;
            }

            i {
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                color: #ced4da;
                pointer-events: none;
            }
        }
    }

    .range-text {
        align-self: center;
        margin: 0 15px;
    }

    .filters {
        &-rule {
            .selector-input {
                width: 100%;
            }

            .field {
                padding-top: 0;
                height: auto;
            }

            .toggle {
                padding: 6px 0;
            }

            input[type="text"],
            input[type="number"],
            input[type="date"] {
                width: 100%;
                height: auto;
                padding: 8px 0;
                border-bottom: 1px solid #ced4da;
                font-size: 14px;
                line-height: 1;
            }

            .vdp-datepicker {
                width: 100%;
            }

            .enum-container {
                .enum {
                    margin-left: 0;
                }
            }
        }
    }

    .filters-rule-checkbox {
        cursor: pointer;
        user-select: none;
        white-space: nowrap;
        margin-right:10px;
        display: flex;
        align-items: center;
        label{cursor: pointer; margin:0 10px 0; user-select: none;}
        input[type=checkbox]{margin-top: 3px;}
    }

    .requirements-label {
        margin-bottom: 10px;
        font-size: 12px;
        color: #8c8c8c;
    }

    .filters-rule-handler {
        display: flex;
        align-items: center;
    }

    .sort-trigger {
        background: transparent;
        border: 0;
        color: #8c8c8c;
        display: inline-block;
        padding: 0;
        margin-right: 10px;
        outline: none;

        &:disabled {
            color: #ced4da;
        }

        &:hover {
            color: #292c33;
        }
    }
</style>
